export const ADD_STATE_COMMENT_BOX = "ADD_STATE_COMMENT_BOX";
export const ADD_STATE_GRID_TEXT_BOX = "ADD_STATE_GRID_TEXT_BOX";
export const ADD_STATE_SIGLE_TEXT_BOX = "ADD_STATE_SIGLE_TEXT_BOX";
export const ADD_STATE_GRID_SIGLE_CHOISE = "ADD_STATE_GRID_SIGLE_CHOISE";
export const ADD_STATE_GRID_MULTI_CHOISE = "ADD_STATE_GRID_MULTI_CHOISE";
export const ADD_STATE_GRID_SIGLE_TEXT = "ADD_STATE_GRID_SIGLE_TEXT";
export const ADD_STATE_MULTI_CHOICE = "ADD_STATE_MULTI_CHOICE";
export const ADD_STATE_SIGLE_CHOICE = "ADD_STATE_SIGLE_CHOICE";
